export const UI_updateShowSessionExpiredModalReducer = {
  UI_updateShowSessionExpiredModal: (state, action) => {
    state.showSessionExpiredModal = action.payload;
  },
};
